import fr from '@/data/fr'

export default { fr }